import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    Q1: null, 
    Q2: null, 
    Q3: null, 
    Q3a: null,
    Q4: null,
    Q4a: null, 
    Q4aa: null, 
    Q4b: null,
    Q4ba: null,
    Q4baa: null,
}

const calculatorQuestionsSlice = createSlice({
    name: 'calculatorQuestions',
    initialState,
    reducers: {
        setQuestion: (state, action) => {
            state[action.payload.index] = action.payload.value;
        },
        resetQuestions: (state) => {
            state = {...initialState};
        }
    }
});

export const { setQuestion, resetQuestions } = calculatorQuestionsSlice.actions;
export const selectCalculatorQuestions = state => state.calculatorQuestions;
export default calculatorQuestionsSlice.reducer;